import { Palette, Trash2 } from "lucide-react";
import { calcItem, inr, UOMS, GSTS } from "../../lib/format";
import { PhotoPicker } from "./PhotoPicker";

export const ItemCard = ({ index, item, tried, onChange, onRemove, onUploading, known = [], onAddColour }) => {
  const c = calcItem(item);
  const set = (k) => (e) => onChange({ [k]: e.target.value });
  const pickDesc = (e) => {
    const v = e.target.value;
    const m = known.find((k) => k.description.toLowerCase() === v.trim().toLowerCase());
    onChange(m ? { description: v, code: m.code, uom: m.uom, rate: item.rate || m.rate, gst: m.gst }
      : { description: v, ...(known.some((k) => k.code === item.code) ? { code: "" } : {}) });
  };
  const touched = item.description.trim() || Number(item.qty) > 0;
  const descBad = tried && (index === 0 || touched) && !item.description.trim();
  const qtyBad = tried && (index === 0 || touched) && !(Number(item.qty) > 0);
  const t = `item-${index}`;
  return (
    <div className="panel rise space-y-3 p-4" data-testid={`item-card-${index}`}>
      <div className="flex items-center justify-between">
        <span className="font-heading text-base font-bold">Item {index + 1}</span>
        <button type="button" className="icon-btn hover:!text-destructive" onClick={onRemove} aria-label="Remove item" data-testid={`${t}-remove-btn`}>
          <Trash2 size={18} />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="col-span-2 min-w-0">
          <label className="label">Item description *</label>
          <input className={`field ${descBad ? "!border-destructive" : ""}`} value={item.description} onChange={pickDesc} list={`${t}-known`}
            placeholder="Cotton Poplin" data-testid={`${t}-description-input`} />
          <datalist id={`${t}-known`}>{known.map((k) => <option key={k.code} value={k.description}>{k.code}</option>)}</datalist>
        </div>
        <div className="min-w-0">
          <label className="label">Item code</label>
          <input className="field mono" value={item.code} onChange={set("code")} placeholder="Auto" data-testid={`${t}-code-input`} />
        </div>
        <div className="col-span-3 min-w-0">
          <label className="label">Colour</label>
          <input className="field" value={item.colour || ""} onChange={set("colour")} placeholder="e.g. Navy (optional)" data-testid={`${t}-colour-input`} />
        </div>
        <div className="min-w-0">
          <label className="label">Qty *</label>
          <input className={`field mono ${qtyBad ? "!border-destructive" : ""}`} type="number" inputMode="decimal" min="0" step="any"
            value={item.qty} onChange={set("qty")} data-testid={`${t}-qty-input`} />
        </div>
        <div className="min-w-0">
          <label className="label">UOM</label>
          <select className="field" value={item.uom} onChange={set("uom")} data-testid={`${t}-uom-select`}>
            {UOMS.map((u) => <option key={u}>{u}</option>)}
          </select>
        </div>
        <div className="min-w-0">
          <label className="label">Rate ₹</label>
          <input className="field mono" type="number" inputMode="decimal" min="0" step="any" value={item.rate} onChange={set("rate")}
            data-testid={`${t}-rate-input`} />
        </div>
      </div>
      <div>
        <span className="label">GST %</span>
        <div className="seg">
          {GSTS.map((g) => (
            <button type="button" key={g} data-active={Number(item.gst) === g} onClick={() => onChange({ gst: g })} data-testid={`${t}-gst-${g}`}>{g}%</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 rounded-lg bg-muted/60 p-3 text-sm">
        <Calc label="Taxable" value={inr(c.taxable)} testid={`${t}-taxable`} />
        <Calc label="Tax" value={inr(c.tax)} testid={`${t}-tax`} />
        <Calc label="Total" value={inr(c.total)} testid={`${t}-total`} strong />
      </div>
      <PhotoPicker photos={item.photos} onChange={(photos) => onChange({ photos })} onUploading={onUploading} testid={t} />
      {onAddColour && item.description.trim() && (
        <button type="button" className="btn btn-outline w-full border-dashed" onClick={onAddColour} data-testid={`${t}-add-colour-btn`}>
          <Palette size={18} /> Add another colour of this item
        </button>
      )}
    </div>
  );
};

const Calc = ({ label, value, testid, strong }) => (
  <div className="min-w-0">
    <p className="mono-label text-muted-foreground">{label}</p>
    <p className={`mono truncate ${strong ? "font-bold" : "font-medium"}`} data-testid={testid}>{value}</p>
  </div>
);
